/**
 * 时间格式化工具 —— 全站统一显示北京时间（Asia/Shanghai）
 *
 * 用法：
 *   import { fmtCST, fmtCSTRel, dayjsCST } from '../utils/time';
 *   fmtCST(order.created_at)                // '2026-05-15 14:30'
 *   fmtCST(order.created_at, 'MM-DD HH:mm') // '05-15 14:30'
 *   fmtCSTRel(notif.created_at)             // '5 分钟前'
 *
 * 注意：
 *   - dayjs 默认按浏览器本地时区解析格式化，在中国本地浏览器看起来已经是 CST
 *   - 但若用户浏览器在其他时区（境外 VPN / Mac 系统时区被改了），不强制 .tz('Asia/Shanghai')
 *     会显示成那个时区，本工具确保任何环境下都显示北京时间
 */
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/zh-cn';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.locale('zh-cn');

const TZ = 'Asia/Shanghai';

/**
 * 取一个固定在北京时区的 dayjs 实例
 */
export function dayjsCST(ts) {
  return ts ? dayjs(ts).tz(TZ) : null;
}

/**
 * 格式化为北京时间字符串
 * @param {string|Date|null} ts
 * @param {string} fmt - dayjs 格式串，默认 'YYYY-MM-DD HH:mm'
 * @param {string} fallback - 空值时返回的占位，默认 '--'
 */
export function fmtCST(ts, fmt = 'YYYY-MM-DD HH:mm', fallback = '--') {
  if (!ts) return fallback;
  const d = dayjs(ts);
  if (!d.isValid()) return fallback;
  return d.tz(TZ).format(fmt);
}

/**
 * 相对时间（XX 分钟前 / XX 小时前 / XX 天前），基准是北京时间
 */
export function fmtCSTRel(ts, fallback = '--') {
  if (!ts) return fallback;
  const d = dayjs(ts);
  if (!d.isValid()) return fallback;
  return d.tz(TZ).fromNow();
}

export { TZ };
